import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { getScreenTypeIconByOrientation } from '../../service/IndoorOutdoorHelpers/IndoorOutdoorHelpers';
import {
    CheckBoxChangeData,
    DisplayPoint,
    MapType,
    Screen
} from '../../typings/displayMap';
import {
    CheckboxDecorator,
    CheckboxDecoratorCheckedItem
} from '../CheckboxDecorator/CheckboxDecorator';
import { Shape2, Shape2Tone } from '../Shape2/Shape2';

import './DisplayMapBalloon.css';

export interface DisplayMapBalloonProps {
    pointData: DisplayPoint;
    onCaptionClick: (groupId: string) => void;
    onScreensSelect: (data: CheckBoxChangeData) => void;
    selectedScreens: string[];
    mapType: MapType;
}

const BLOCK = 'display-map-balloon';

export class DisplayMapBalloon extends React.PureComponent<
    DisplayMapBalloonProps
> {
    render() {
        const { pointData, selectedScreens, mapType } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: { 'map-type': mapType }
                })}
            >
                {pointData.screens.map((group: Screen, index: number) => {
                    const isDeleted =
                        group.screenWeight === group.deletedScreenWeight;

                    return (
                        <div
                            className={Bem.cls({
                                block: BLOCK,
                                elem: 'group',
                                mods: {
                                    deleted: isDeleted
                                }
                            })}
                            key={index}
                        >
                            <div className={Bem.cls(BLOCK, 'checkbox-area')}>
                                <CheckboxDecorator
                                    cls={Bem.cls(BLOCK, 'checkbox')}
                                    theme={'normal'}
                                    view={'default'}
                                    size={'s'}
                                    onChecked={this.onCheck(group.id)}
                                    checked={selectedScreens.includes(group.id)}
                                />
                            </div>
                            {this.getLabel(group)}
                            {this.getScreensShortInfo(group)}
                        </div>
                    );
                })}
            </div>
        );
    }

    private getLabel = (group: Screen) => {
        const { mapType } = this.props;

        let labelContent;

        switch (mapType) {
            case MapType.outdoor:
                labelContent = (
                    <div className={Bem.cls(BLOCK, 'operator-name')}>
                        {group.operatorName}
                    </div>
                );
                break;
            case MapType.indoor:
                labelContent = (
                    <div className={Bem.cls(BLOCK, 'zone')}>
                        {group.zoneCategory + ' · ' + group.facilityType}
                    </div>
                );
                break;
            default:
                return null;
        }

        return (
            <div className={Bem.cls(BLOCK, 'label')}>
                <div
                    className={Bem.cls(BLOCK, 'caption')}
                    onClick={() => {
                        this.onCaptionClick(group.id);
                    }}
                >
                    {group.caption}
                </div>
                {labelContent}
            </div>
        );
    };

    private getScreensShortInfo = (group: Screen) => {
        const { mapType } = this.props;

        if (mapType === MapType.outdoor) {
            return null;
        }

        return (
            <div className={Bem.cls(BLOCK, 'screens-short-info')}>
                <div className={Bem.cls(BLOCK, 'screens-count')}>
                    {group.screenWeight}
                </div>
                {group.orientation && (
                    <Shape2
                        cls={Bem.cls(BLOCK, 'screens-side')}
                        width={16}
                        height={16}
                        tone={Shape2Tone.grey}
                        icon={getScreenTypeIconByOrientation(group.orientation)}
                    />
                )}
            </div>
        );
    };

    private onCheck = (groupId: string) => (
        event: React.KeyboardEvent<HTMLElement>,
        checkboxData: CheckboxDecoratorCheckedItem
    ) => {
        const { onScreensSelect, pointData } = this.props;

        if (onScreensSelect) {
            onScreensSelect({
                id: groupId,
                regionId: pointData.regionId,
                checked: checkboxData.checked
            });
        }
    };

    private onCaptionClick = (groupId: string) => {
        this.props.onCaptionClick(groupId);
    };
}
